var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-percent-pond',{staticStyle:{"width":"200px","height":"100px"},attrs:{"config":_vm.config}})
}
var staticRenderFns = []

export { render, staticRenderFns }